import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  edgeRailColors: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
